import React, { useState, useEffect} from 'react';

import cloneDeep from 'lodash/cloneDeep';

import post from '../logic/Loader';
import GlobalData from '../logic/GlobalData';

import Header from './header';
import Footer from './footer';
import Words from './words';

import {saveCookieObj, readCookieObj} from '../logic/Cookie';

const useConstructor = (callBack = () => {}) => {
  const [hasBeenCalled, setHasBeenCalled] = useState(false);
  if (hasBeenCalled) return;
  callBack();
  setHasBeenCalled(true);
}

export default function App(props) {

  const [isLoad, setIsLoad] = React.useState(false);

  useConstructor(() => {

    GlobalData.busy = false;

    if(GlobalData.funct == undefined)
      GlobalData.funct = {};

    if(GlobalData.settings == undefined)
      GlobalData.settings = {};

    let cookie_settings = readCookieObj('settings');

    if(cookie_settings) {
      GlobalData.settings = cookie_settings;
    } else {
      GlobalData.settings = {'lang':'ua', 'voice':'samantha', 'volume':1};
      saveCookieObj('settings', GlobalData.settings);
    }

    let params = {
      lang: GlobalData.settings.lang
    };

    post('/post/words/getdata/', params, (data) => {
      GlobalData.data = data;

      setIsLoad(true);
    });

  }, []);

  
  return (
    <>
      {isLoad && 
        <>
          <Header />
          <Words />
          <Footer />
        </>
      }
    </>
  );
}